<template>
<div>
  <ProductCard v-bind:products="products"></ProductCard>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions} from 'vuex'
import navbar from "../narbar";
import ProductCard from "../ProductCard";
export default {
  data () {
    return {    
    }
  },
  computed:{
      ...mapState({
        products: state => state.products.all
      }),

  },
  components:{
    navbar: navbar,
    ProductCard: ProductCard,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/ProductPageAll.vue